import React from 'react';
import PropTypes from 'prop-types';
import {
  formatLtvMetricDisplay,
  toLtvPercentage,
} from '../../utils/cryptoUtils';

const LtvSummaryCard = ({
  collateralHeld,
  currentLtv,
  contractualLtvPct,
  marginCallThreshold,
  liquidationThreshold,
  ltvVariant: ltvVariantOverride,
  showContractualWarning = true,
}) => {
  const currentLtvDisplay = formatLtvMetricDisplay(currentLtv);
  const currentLtvPct = toLtvPercentage(currentLtv);
  const isAboveContractual = contractualLtvPct != null
    && currentLtvPct != null
    && currentLtvPct > contractualLtvPct;

  const ltvVariant = ltvVariantOverride ?? (() => {
    if (currentLtvPct == null) return 'healthy';
    if (liquidationThreshold != null && currentLtvPct >= liquidationThreshold) return 'critical';
    if (marginCallThreshold != null && currentLtvPct >= marginCallThreshold) return 'warning';
    if (contractualLtvPct != null && currentLtvPct > contractualLtvPct) return 'drifted';
    return 'healthy';
  })();

  return (
    <div className="lower-ltv-modal__deposit-box">
      <div className="lower-ltv-modal__summary-row">
        <div>
          <small className="lower-ltv-modal__summary-label">COLLATERAL HELD</small>
          <div className="lower-ltv-modal__summary-value">{collateralHeld}</div>
        </div>
        <div className="lower-ltv-modal__summary-metric--right">
          <small className="lower-ltv-modal__summary-label">CURRENT LTV</small>
          <div className={`lower-ltv-modal__summary-value lower-ltv-modal__summary-value--${ltvVariant}`}>
            {currentLtvDisplay}
          </div>
        </div>
      </div>
      {showContractualWarning && isAboveContractual && (
        <div className="lower-ltv-modal__summary-warning">
          <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M12 4 3 20h18L12 4Z"
              fill="none"
              stroke="#ea580c"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path d="M12 9v5" stroke="#ea580c" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="17" r="1.2" fill="#ea580c" />
          </svg>
          <span>
            If your LTV reaches
            {' '}
            <strong>{`${liquidationThreshold}%`}</strong>
            , your collateral may be liquidated.
          </span>
        </div>
      )}
    </div>
  );
};

LtvSummaryCard.propTypes = {
  collateralHeld: PropTypes.string.isRequired,
  currentLtv: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  contractualLtvPct: PropTypes.number,
  marginCallThreshold: PropTypes.number,
  liquidationThreshold: PropTypes.number,
  ltvVariant: PropTypes.oneOf(['healthy', 'drifted', 'warning', 'critical']),
  showContractualWarning: PropTypes.bool,
};

LtvSummaryCard.defaultProps = {
  contractualLtvPct: null,
  marginCallThreshold: 75,
  liquidationThreshold: 90,
  ltvVariant: undefined,
  showContractualWarning: true,
};

export default LtvSummaryCard;
